let imageBuffer = null;
let imageBufferWidth = null;
let imageBufferHeight = null;

function getRenderBuffer(width, height) {
    if (imageBuffer == null || imageBufferWidth !== width || imageBufferHeight !== height) {
        imageBuffer = null;

        imageBuffer = document.createElement('canvas');

        imageBufferWidth = width;
        imageBufferHeight = height;

        imageBuffer.width = imageBufferWidth;
        imageBuffer.height = imageBufferHeight;
    }

    return {
        imageBuffer,
        imageBufferWidth,
        imageBufferHeight,
    };
}

function getLoader() {
}

export {
    getRenderBuffer,
    getLoader,
};
